import React from 'react';
import DataTable from 'react-data-table-component';
import { MenuComponent } from '../../assets/ts/components';
type Props = {
  data: any;
  columns: any[];
  selectableRows?: boolean;
  onSelectedRowsChange?: (selected: any) => void;
  selectableRowDisabled?: (row: any) => boolean;
  clearSelectedRows?: boolean;
};

const TableList: React.FC<Props> = ({ 
  data, 
  columns, 
  selectableRows, 
  onSelectedRowsChange,
  selectableRowDisabled,
  clearSelectedRows,
}) => {
  const handlePageChange = () => {
    MenuComponent.reinitialization();
  };

  const handleRowsChange = () => {
    MenuComponent.reinitialization();
  };
  return (
    <>
      <div className="card-body py-3">
        <DataTable
          keyField="id"
          columns={columns}
          data={data}
          expandableRowsHideExpander
          pagination
          responsive
          selectableRows={selectableRows}
          onSelectedRowsChange={onSelectedRowsChange}
          selectableRowDisabled={selectableRowDisabled}
          clearSelectedRows={clearSelectedRows}
          paginationRowsPerPageOptions={[5, 10, 20, 50]}
          customStyles={{
            table: {
              style: {
                minHeight: 'auto',
              },
            },
            rows: {
              style: {
                borderBottom: '1px dashed #e4e6ef !important',
                paddingTop: '5px',
                paddingBottom: '5px',
              },
            },
            headRow: {
              style: {
                borderBottom: '1px dashed  #e4e6ef',
              },
            },
            pagination: {
              style: {
                borderTopStyle: 'none',
                minHeight: '45px',
              },
            },
          }}
          paginationComponentOptions={{
            rowsPerPageText: 'Registros por página',
            rangeSeparatorText: 'de',
            selectAllRowsItem: false,
          }}
          noDataComponent={
            <>
              <div className="d-flex align-items-center">
                <div className="text-muted text-center fs-6 w-100 m-5">
                  Sin registros
                </div>
              </div>
            </>
          }
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsChange}
          persistTableHead
        ></DataTable>
      </div>
    </>
  );
};

export { TableList };
